export function stopPropagation(event, callback = () => { }) {
    event.stopPropagation();
    callback();
}
